import ErrorPagesNotFound, {
	LazyNotFoundErrorPage,
} from '@jira/router-routes__common/src/ui/error-pages/not-found/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { errorsNotFoundRoute } from '@jira/router-routes__errors-not-found-routes/src/errorsNotFoundRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const errorsNotFoundRouteEntry: Route = createEntry(errorsNotFoundRoute, () => ({
	group: 'errors',
	// eslint-disable-next-line no-restricted-syntax
	component: ErrorPagesNotFound,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyAtlassianNavigation, LazyNotFoundErrorPage],

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
